import { AccountModule, RootState } from '../redux';
// import { NotificationsModule } from '../redux';
import { DispatchProp, connect } from 'react-redux';
// import {
//   HBorder,
//   HContainer,
//   HSpace,
//   VBorder,
//   VContainer,
//   VSpace,
// } from '../components/UI/more_detail/container';
import { /*PlanInfo,*/ SubscriptionInfo } from '../redux/modules/account';
import React, {
  // ChangeEvent,
  // createRef,
  FC,
  // FormEvent,
  // KeyboardEvent,
  // PureComponent,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled, { theme } from '../theme';
import { Crisp } from 'crisp-sdk-web';
// import { AccountAvatar } from '../components/UI/avatar';
// import { AvatarModal } from '../modals/avatar_modal';
import { BillingItem } from '../components/account_settings/billing_grid_row';
// import { BillingTable } from '../components/account_settings/billing_table';
// import Bind from 'lodash-decorators/bind';
// import { CancellationModal } from '../modals/cancellation-modal';
// import { ChangePlanModal } from '../modals/change_plan_modal';
// import { Config } from '../utils';
// import { ContentSection } from '../components/content/content_section';
// import { PageContent } from '../components/content/page_content';
// import { PageHeader } from '../components/content/page_header';
// import SelectList from '../components/UI/select-list';
import {
  getCustomerPlanInfo,
  getCustomerBillingHistory,
  // cancelSubscription,
  getLastDigits,
  // updateStripeProfile,
  // updateStripePayment,
  createCustomerSession,
} from '../api/stripe';
import { /* updateCrispProfile, */ getCrispProfile } from '../api/crisp';
// import { UpdateCreditCardModal } from '../modals/update_credit_card';
// import { ValidationError } from "@quipa/api";
// import { detect } from 'detect-browser';
// import moment from 'moment';
// import { BillingHistoryModal } from '../modals/billing_history';
// import { FadeLoader } from 'react-spinners';
import {
  // updateAccount,
  // uploadImage,
  getAccount,
  // getPlans,
  // subscribeAccount,
  // changeSubscriptionPlan,
  retrieveMetadata,
  // changeCard,
} from '../api/account';
import TrashBlack from './../assets/icons/trash_black.svg';
import PencilBlack from './../assets/icons/pencil_black.svg';
import { seedItemsOnLogin } from '../api/item';
import { getTotalNumberCount } from '../api/drapery-order';
import { trackView } from '../components/analytics/track_view';
import { MixpanelEvents } from '../components/analytics/mix_panel_events';
// import { quickbooksOauth } from '../api/quickbooks';
import Button from '../ui_components/button/button';
import Checkbox from '../ui_components/checkbox/checkbox';
import { ValidationPopupInput } from '../ui_components/validation/validationPopupInput';
import { Loader } from '../ui_components/loader';
import ValidationForm from '../ui_components/validation/validationForm';
import { RouteComponentProps } from 'react-router-dom';
import { checkGate } from '../statsig';
import { getUser } from '../api/users';
import {
  LucideBuilding2,
  LucideCreditCard,
  LucideEye,
  LucideFileText,
  LucideListChecks,
} from 'lucide-react';
import BusinessInfo from '../components/account_settings/tabs/BusinessInfo';
import DescriptionSettings from '../components/account_settings/tabs/DescriptionSettings';
// Uncomment when needed to implement
// import InvoiceAndEstimate from '../components/account_settings/tabs/InvoiceAndEstimate';
import QuipaSubscription from '../components/account_settings/tabs/Subscription';
import Estimate from '../components/account_settings/tabs/Estimate';

// const PRICING_TABLE_PLANS_GATE = 'pricing_table_plans';

interface AccountSettingsProps {
  /**
   * Account id
   */
  accountId: number;
  /**
   * True when quickbook account was check-connection
   */
  quickbookConnected: boolean;
  /**
   * Account last card digits
   */
  // cardDigits: string | null;
  /**
   * User role
   */
  userRole: 'admin' | 'office_worker';
  /**
   * User role
   */
  type: 'subscribed' | 'unsubscribed';
  account?: any;
  managedAccountId?: any;
  ownerId?: any;
  handleRefetchAccount?(): void;
}

export const SaveButton = styled(Button)`
  // width: 130px;
  box-shadow: none !important;
  border: 1px solid #c6c6c6;
  border-radius: 0.5em;
  display: block;
  margin-left: auto;
`;

export const ChangePlanButton = styled(Button)`
  width: 150px !important;
  box-shadow: none !important;
`;

export const BuyMoreOrdersButton = styled(Button)`
  width: 150px;
  box-shadow: none;
  border: 1px solid #c6c6c6;
  border-radius: 0.5em;
  display: block;
`;

export const BilllingCommentSpan = styled.span`
  color: #3b97b1 !important;
`;

export const Form = styled(ValidationForm)`
  font-weight: 400 !important;
  width: 97% !important;
  max-width: 1200px !important;
`;

export const FormSubtitle = styled.h4`
  color: #3b97b1 !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
  font-size: 16px !important;
`;

export const Subtitle = styled.h4`
  color: #000 !important;
  font-weight: 400 !important;
  margin-top: 0 !important;
  margin-top: 30px !important;
`;

export const Content = styled.h4`
  color: ${theme.colors.grayRGBA} !important;
  font-weight: 400 !important;
  margin-top: 0 !important;
`;

export const FormLabel = styled.label`
  color: ${theme.colors.grayRGBA} !important;
  font-weight: 400 !important;

  .red-asterisk {
    color: #ff6084 !important;
  }
`;

export const FormInput = styled(ValidationPopupInput)`
  height: 34px !important;
  border-color: #3b97b1 !important;
`;

export const DisableAutocompleteInput = styled.input`
  display: none !important;
`;

export const BillingCheckBox = styled(Checkbox)`
  margin: 10px 0 !important;
`;

// const SubContentSection = styled.div`
//   min-width: 800px !important;
// `;

// const ClientSettingsAdittionalForm = styled.div`
//   margin-left: 20px !important;
//   width: 80% !important;
//   display: flex !important;
// `;

// const SubtitleWrapper = styled.div`
//   display: flex !important;
//   align-items: center !important;

//   > h4 {
//     margin: 0 !important;
//   }

//   > h4:last-child {
//     margin-left: 5px !important;
//   }

//   > span {
//     margin-left: 70px !important;
//     cursor: pointer !important;
//   }
// `;

// const ClientSettingsTextArea = styled(TextArea)`
//     max-width: 450px;
//     height: 80px;
//     font-size: 13px;
// `;

// const AvatarContainer = styled.div`
//   flex: 1 !important;
//   min-width: 220px !important;
//   max-width: 350px !important;
//   width: 100% !important;
// `;

// const AvatarActionContainer = styled.div`
//   display: flex !important;
//   justify-content: center !important;
//   margin-top: 30px !important;
// `;

// const GrayBorder = styled.span`
//   padding: 11px 0 6px !important;
//   border: 1px solid #969696 !important;
//   margin: 0 10px 0 15px !important;
// `;

export const TrashDelete = styled(TrashBlack)`
  width: 16px !important;
  height: 16px !important;
  cursor: pointer !important;
`;
export const PencilEdit = styled(PencilBlack)`
  width: 16px !important;
  height: 16px !important;
  cursor: pointer !important;
`;

// const ConfirmationEmail = styled.div`
//     color: #ff6084;
//     font-style: italic;
//     margin-top: 20px;
// `;

const defaultBillingInfoValues = (): AccountModule.BillingInfo => ({
  companyName: '',
  email: '',
  address: '',
  unitSuite: '',
  city: '',
  state: '',
  zipCode: '',
});

const defaultFieldValues = (): AccountInfoFields => ({
  avatarId: '',
  billingInfo: defaultBillingInfoValues(),
  clientFacingInfo: defaultBillingInfoValues(),
  sameAsBilling: false,
});

interface AccountInfoFields {
  avatarId?: string | null;
  billingInfo: AccountModule.BillingInfo;
  clientFacingInfo: AccountModule.BillingInfo;
  sameAsBilling: boolean;
}

export type DescriptionSettingsStateType = {
  orderingDescription: any[];
  salesDescriptionCom: any[];
  salesDescriptionWorkroom: any[];
};

const ACCOUNT_SETTINGS_TAB_KEYS = {
  BUSINESS_INFO: 'business_info',
  QUIPA_SUBSCRIPTION: 'quipa_subscription',
  ESTIMATE: 'estimate',
  DESCRIPTION_SETTINGS: 'description_settings',
} as const;

const resolveAccountSettingsTabFromLocation = (
  location: RouteComponentProps['location']
): number => {
  const searchTab = new URLSearchParams(location.search || '').get('tab');
  const hash = location.hash || '';
  const hashQueryIndex = hash.indexOf('?');
  const hashTab =
    hashQueryIndex >= 0 ? new URLSearchParams(hash.slice(hashQueryIndex + 1)).get('tab') : null;
  const requestedTab = (searchTab || hashTab || '').toLowerCase();

  switch (requestedTab) {
    case ACCOUNT_SETTINGS_TAB_KEYS.QUIPA_SUBSCRIPTION:
      return 1;
    case ACCOUNT_SETTINGS_TAB_KEYS.ESTIMATE:
      return 2;
    case ACCOUNT_SETTINGS_TAB_KEYS.DESCRIPTION_SETTINGS:
    case 'component_desc':
      return 3;
    case ACCOUNT_SETTINGS_TAB_KEYS.BUSINESS_INFO:
    default:
      return 0;
  }
};

// interface State {
//   historyItems: BillingItem[];
//   plans: PlanInfo[];
//   formLoading: boolean;
//   historyLoading: boolean;
//   creditCardModalActive: boolean;
//   billingHistoryModalActive: boolean;
//   changePlanModalActive: boolean;
//   formFields: AccountInfoFields;
//   imageModalOpen: boolean;
//   estimateNotes: string;
//   planInfoError: boolean;
//   lastFourError: boolean;
//   historyItemsError: boolean;
//   last4: string;
//   isCancellationModalOpen: boolean;
//   updateCardError: string;
//   isCancellationMembership: boolean;
//   currentPlanInfo: SubscriptionInfo | undefined;
//   planLimitInfo: {
//     orderLimit: number | undefined;
//     orderLimitLeft: number | undefined;
//   };
//   planInterval: string | undefined;
//   errorOrderLimit: boolean;
//   planLimitLoading: boolean;
//   extraItemOrder: number;
//   remainingItemOrder: number;
//   customerSecret: string | null;
//   buyMoreOrders: boolean;
//   showMoreOrdersButton?: boolean;
//   stripeControlsEnabled: boolean;
//   isSubUserAccount: boolean;
//   accountIsAdmin: boolean;
//   accountIsOwner: boolean;
//   canEditSharedSettings: boolean;
//   managedAccountId: number;
//   seatUsageUsed: number;
//   seatUsageAvailable: number;
//   seatUsagePending: number;
// }

const AccountSettingsPage: FC<AccountSettingsProps & DispatchProp & RouteComponentProps> = (
  props
) => {
  const account = props.account;
  const accountId = account?.parentAccountId || account?.id || props.accountId || 0;
  const resizeObserver = useRef<any | undefined>(undefined);
  const gatePollIntervalId = useRef<number | undefined>(undefined);
  const sectionRef = useRef<any>(null);
  const hostRef = useRef<any>(null);

  const [historyItems, setHistoryItems] = useState<BillingItem[]>([]);
  const [last4, setLast4] = useState<string>('');
  const [formLoading, setFormLoading] = useState<boolean>(true);
  const [historyLoading, setHistoryLoading] = useState<boolean>(true);
  const [formFields, setFormFields] = useState<AccountInfoFields>(defaultFieldValues());
  const [estimateFields, setEstimateFields] = useState<any>(null);
  const [descriptionSettings, setDescriptionSettings] = useState<DescriptionSettingsStateType>({
    orderingDescription: [],
    salesDescriptionCom: [],
    salesDescriptionWorkroom: [],
  });
  const [planInfoError, setPlanInfoError] = useState<boolean>(false);
  const [lastFourError, setLastFourError] = useState<boolean>(false);
  const [historyItemsError, setHistoryItemsError] = useState<boolean>(false);
  const [currentPlanInfo, setCurrentPlanInfo] = useState<SubscriptionInfo | undefined>(undefined);
  const [planLimitInfo, setPlanLimitInfo] = useState<{
    orderLimit: number | undefined;
    orderLimitLeft: number | undefined;
  }>({
    orderLimit: undefined,
    orderLimitLeft: undefined,
  });
  const [extraItemOrder, setExtraItemOrder] = useState<number>(0);
  const [remainingItemOrder, setRemainingItemOrder] = useState<number>(0);
  const [planInterval, setPlanInterval] = useState<string | undefined>(undefined);
  const [errorOrderLimit, setErrorOrderLimit] = useState<boolean>(false);
  const [planLimitLoading, setPlanLimitLoading] = useState<boolean>(false);
  const [customerSecret, setCustomerSecret] = useState<string | null>(null);
  const [showMoreOrdersButton, setShowMoreOrdersButton] = useState<boolean | undefined>(undefined);
  const [stripeControlsEnabled, setStripeControlsEnabled] = useState<boolean>(true);
  const [isSubUserAccount, setIsSubUserAccount] = useState<boolean>(!!props.ownerId || false);
  const [accountIsAdmin, setAccountIsAdmin] = useState<boolean>(
    account?.isAdmin || account?.isOwner || false
  );
  const [accountIsOwner, setAccountIsOwner] = useState<boolean>(account?.isOwner || false);
  const [canEditSharedSettings, setCanEditSharedSettings] = useState<boolean>(
    account?.isAdmin || account?.isOwner || true
  );
  const [managedAccountIdState, setManagedAccountIdState] = useState<number>(
    props.managedAccountId || 0
  );
  const [seatUsageUsed, setSeatUsageUsed] = useState<number>(0);
  const [seatUsageAvailable, setSeatUsageAvailable] = useState<number>(0);
  const [seatUsagePending, setSeatUsagePending] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  // TABS
  const [activeTab, setActiveTab] = useState<number>(
    resolveAccountSettingsTabFromLocation(props.location)
  );

  // ### FUNCTIONS ###
  const handleLoading = (val: boolean) => {
    setLoading(val);
  };

  const handleActivateTab = (val: number) => {
    const nextTab = val || 0;
    setActiveTab(nextTab);

    const searchParams = new URLSearchParams(props.location.search || '');
    if (nextTab === 3) {
      searchParams.set('tab', ACCOUNT_SETTINGS_TAB_KEYS.DESCRIPTION_SETTINGS);
    } else if (nextTab === 2) {
      searchParams.set('tab', ACCOUNT_SETTINGS_TAB_KEYS.ESTIMATE);
    } else if (nextTab === 1) {
      searchParams.set('tab', ACCOUNT_SETTINGS_TAB_KEYS.QUIPA_SUBSCRIPTION);
    } else {
      searchParams.delete('tab');
    }

    props.history.replace({
      pathname: props.location.pathname,
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      hash: '',
    });
  };

  useEffect(() => {
    const resolvedTab = resolveAccountSettingsTabFromLocation(props.location);
    if (resolvedTab !== activeTab) {
      setActiveTab(resolvedTab);
    }
  }, [activeTab, props.location]);

  // const getManagedAccountId = (): number => {
  //   return managedAccountId || accountId;
  // };

  const loadCurrentPlanInfo = async () => {
    // const accountId = getManagedAccountId();

    const planInfoRes = await getCustomerPlanInfo(accountId);

    if (planInfoRes.error) {
      console.error(planInfoRes?.message || 'Error while getting account plan info');
      return;
    }

    let planInfo = planInfoRes['main'];
    let planInfoSeat = planInfoRes['seat'];

    if (
      planInfo &&
      planInfoRes &&
      planInfoRes.error &&
      planInfoRes.error.response &&
      planInfoRes.error.response.data &&
      planInfoRes.error.response.data.error &&
      planInfoRes.error.response.data.error.includes('No such customer')
    ) {
      setPlanInfoError(true);
    } else {
      const item_order =
        planInfo && planInfo.product_metadata && planInfo.product_metadata.item_order
          ? planInfo.product_metadata.item_order.toString()
          : '';

      const currentStore = localStorage.getItem('quipa-store');

      let storeObj = currentStore ? JSON.parse(currentStore) : {};

      storeObj.user = {
        ...(storeObj.user || {}),
        item_order,
      };

      localStorage.setItem('quipa-store', JSON.stringify(storeObj));

      setCurrentPlanInfo({
        planType: planInfo.object,
        planName: planInfo.planName,
        startDate: new Date(planInfo.current_period_start * 1000),
        renewalDate: new Date(planInfo.current_period_end * 1000),
        monthlyPrice: planInfo && planInfo.plan && planInfo.plan.amount,
        planId: planInfo && planInfo.plan && planInfo.plan.id,
        promoId: planInfo.discount && planInfo.discount.promotion_code,
        cancelAtPeriodEnd: planInfo.canceled_at ? true : false,
        discountAmount:
          planInfo.discount && (planInfo.plan.amount * planInfo.discount.coupon.percent_off) / 100,
      });
      setPlanInterval(
        planInfo && planInfo.plan && planInfo.plan.interval ? planInfo.plan.interval : undefined
      );
      setSeatUsageAvailable(
        planInfo &&
          planInfo.product_metadata &&
          Number.isFinite(Number(planInfo.product_metadata.seats))
          ? Math.max(Number(planInfo.product_metadata.seats) + (planInfoSeat?.quantity || 0), 0)
          : 0
      );
    }
  };

  const loadCurrentPlanLimits = async () => {
    // const accountId = getManagedAccountId();

    setPlanLimitLoading(true);
    const order_limit = await retrieveMetadata(accountId);

    if (order_limit?.error) {
      console.error(order_limit?.error);
      return;
    }

    if (
      order_limit &&
      order_limit.error &&
      order_limit.error.response &&
      order_limit.error.response.data &&
      order_limit.error.response.data.error &&
      order_limit.error.response.data.error.includes('Not Found')
    ) {
      setErrorOrderLimit(true);
    }

    const order_limit_left = await getTotalNumberCount(accountId);

    if (
      (order_limit_left &&
        order_limit_left.error &&
        order_limit_left.error.response &&
        order_limit_left.error.response.data &&
        order_limit_left.error.response.data.error &&
        order_limit_left.error.response.data.error.includes('Not Found')) ||
      (order_limit_left &&
        order_limit_left.response &&
        order_limit_left.response.message &&
        order_limit_left.response.message.includes('Subscription not found'))
    ) {
      setErrorOrderLimit(true);
    }

    if (!planInfoError) {
      let order_limit_number: any = undefined;

      if (order_limit && order_limit.item_order) {
        order_limit_number = +order_limit.item_order;
      }
      setPlanLimitInfo({
        orderLimit: order_limit_number,
        orderLimitLeft: order_limit_left && !order_limit_left.error ? order_limit_left : 0,
      });
    }
    setPlanLimitLoading(false);
  };

  const loadSeatUsageSummary = async () => {
    // const accountId = getManagedAccountId();

    try {
      const user = await getUser({ accountId, includeTeamData: true });
      const teamMembers = Array.isArray(user?.teamContext?.teamMembers)
        ? user.teamContext.teamMembers
        : [];
      const subscribedMembers = teamMembers.filter(
        (member: any) => String(member?.type || '').toLowerCase() === 'subscribed'
      );

      const ownerExistsInTeam = subscribedMembers.some((member: any) => !!member?.isOwner);
      const activeTeamMembersCount =
        subscribedMembers.length > 0 ? subscribedMembers.length + (ownerExistsInTeam ? 0 : 1) : 1;

      const pendingInvitations = Array.isArray(user?.teamContext?.pendingInvitations)
        ? user.teamContext.pendingInvitations
        : [];
      const pendingCount = pendingInvitations.length;

      setSeatUsagePending(pendingCount);
      setSeatUsageUsed(activeTeamMembersCount + pendingCount);
    } catch (error) {
      // Seat usage line is supplemental; keep Account Settings usable on failures.
    }
  };

  const detachResizeObserver = () => {
    if (resizeObserver.current) {
      resizeObserver.current.disconnect();
      resizeObserver.current = undefined;
    }
  };

  const attachResizeObserver = () => {
    detachResizeObserver();

    const host = hostRef.current;
    if (!host || typeof (window as any).ResizeObserver === 'undefined') return;

    resizeObserver.current = new (window as any).ResizeObserver((entries: any) => {
      const entry = entries[0];
      if (!entry) return;
    });

    resizeObserver.current?.observe(host);
  };

  const scrollToSection = (opts?: { smooth?: boolean; headerOffset?: number }) => {
    const el = sectionRef.current;
    if (!el) return;
    const behavior: ScrollBehavior = opts && opts.smooth ? 'smooth' : 'auto';
    const headerOffset = opts && opts.headerOffset ? opts.headerOffset : 0;

    const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({ top, behavior });
  };

  // const handleBuyMoreOrders = async (): Promise<void> => {
  //   setBuyMoreOrders((prev) => !prev);
  // };
  // ### END OF FUNCTIONS ###

  // ### FETCH FUNCTIONS ###
  // ### END OF FETCH FUNCTIONS ###

  // ### USE EFFECTS ###
  useEffect(() => {
    if (account) {
      const initialAccount = async () => {
        let isSubUserAccount = false;
        let accountIsOwner = false;
        let accountIsAdmin = false;
        let managedAccountId = managedAccountIdState;

        let managedAccount = account;
        const parentAccountId = Number(managedAccount.parentAccountId);
        accountIsOwner = !!managedAccount.isOwner;
        accountIsAdmin = !!managedAccount.isAdmin || accountIsOwner;
        isSubUserAccount =
          !accountIsOwner && Number.isFinite(parentAccountId) && parentAccountId > 0;
        managedAccountId = isSubUserAccount ? parentAccountId : accountId;

        if (account?.parentAccountId) {
          const parentAccount = await getAccount(accountId);
          if (!parentAccount || parentAccount.error) {
            setFormLoading(false);
            setHistoryLoading(false);
            setStripeControlsEnabled(false);
            setIsSubUserAccount(isSubUserAccount);
            setAccountIsAdmin(accountIsAdmin);
            setAccountIsOwner(accountIsOwner);
            setCanEditSharedSettings(accountIsAdmin);
            setManagedAccountIdState(managedAccountId);
            handleLoading(false);
            return;
          }
          managedAccount = parentAccount;
        }
        setEstimateFields({
          estimateBundling: managedAccount?.estimateBundling,
          estimateBundlingItems: managedAccount?.estimateBundlingItems,
          taxDefault: managedAccount?.taxDefault,
          estimateExpirationDays: managedAccount?.estimateExpirationDays,
          defaultPaymentTerms: managedAccount?.defaultPaymentTerms,
          defaultTermsAndConditions: managedAccount?.defaultTermsAndConditions,
          accountEstimateSending: managedAccount?.accountEstimateSending,
          additionalCcEmails: managedAccount?.additionalCcEmails,
          additionalReplyToEmails: managedAccount?.additionalReplyToEmails,
        });
        setDescriptionSettings({
          orderingDescription: managedAccount?.orderingDescription || [],
          salesDescriptionCom: managedAccount?.salesDescriptionCom || [],
          salesDescriptionWorkroom: managedAccount?.salesDescriptionWorkroom || [],
        });
        setFormFields((prev) => {
          return {
            ...prev,
            avatarId: managedAccount.avatarId,
            billingInfo: managedAccount.billingInfo,
            clientFacingInfo: managedAccount.clientFacingInfo,
            sameAsBilling: managedAccount.sameAsBilling,
          };
        });
        setExtraItemOrder(managedAccount.extraItemOrder);
        setRemainingItemOrder(managedAccount.remainingItemOrder);
        setFormLoading(false);
        setStripeControlsEnabled(!isSubUserAccount);
        setIsSubUserAccount(isSubUserAccount);
        setAccountIsAdmin(accountIsAdmin);
        setAccountIsOwner(accountIsOwner);
        setCanEditSharedSettings(accountIsAdmin);
        setManagedAccountIdState(managedAccountId);
      };

      initialAccount();
    }

    return () => {};
  }, [account]);

  useEffect(() => {
    const initialFunction = async () => {
      // const { accountId } = props;

      const showMoreOrdersButton = checkGate('more_orders');
      setShowMoreOrdersButton(showMoreOrdersButton);
      gatePollIntervalId.current = window.setInterval(() => {
        const nextShowMoreOrdersButton = checkGate('more_orders');
        if (showMoreOrdersButton !== nextShowMoreOrdersButton) {
          setShowMoreOrdersButton(nextShowMoreOrdersButton);
        }

        if ((window as any).statsigClient && gatePollIntervalId.current !== undefined) {
          window.clearInterval(gatePollIntervalId.current);
          gatePollIntervalId.current = undefined;
        }
      }, 500);

      if (!localStorage.getItem(`login-event-${accountId}`)) {
        localStorage.setItem(`login-event-${accountId}`, 'login' + Math.random());
      }
      // const accountId = parseFloat(localStorage.getItem("accountId") || "0");
      const customerId = localStorage.getItem('customerId') || '';
      // Track View with Mixpanel
      trackView(MixpanelEvents.ACCOUNT_SETTINGS, {});
      // End of code for Track View with Mixpanel

      seedItemsOnLogin();

      // let isSubUserAccount = false;
      // let accountIsOwner = false;
      // let accountIsAdmin = false;
      // let managedAccountId = managedAccountIdState;

      // handleLoading(true);
      // // let managedAccount = await getAccount(managedAccountId);
      // let managedAccount = account
      // // if (managedAccount && !managedAccount.error) {
      //   const parentAccountId = Number(managedAccount.parentAccountId);
      //   accountIsOwner = !!managedAccount.isOwner;
      //   accountIsAdmin = !!managedAccount.isAdmin || accountIsOwner;
      //   isSubUserAccount =
      //     !accountIsOwner && Number.isFinite(parentAccountId) && parentAccountId > 0;
      //   managedAccountId = isSubUserAccount ? parentAccountId : accountId;

      //   if (managedAccountIdState !== accountId) {
      //     const parentAccount = await getAccount(accountId);
      //     if (!parentAccount || parentAccount.error) {
      //       setFormLoading(false);
      //       setHistoryLoading(false);
      //       setStripeControlsEnabled(false);
      //       setIsSubUserAccount(isSubUserAccount);
      //       setAccountIsAdmin(accountIsAdmin);
      //       setAccountIsOwner(accountIsOwner);
      //       setCanEditSharedSettings(accountIsAdmin);
      //       setManagedAccountIdState(managedAccountId);
      //       return;
      //     }
      //     managedAccount = parentAccount;
      //   }

      //   setFormFields((prev) => {
      //     return {
      //       ...prev,
      //       avatarId: managedAccount.avatarId,
      //       billingInfo: managedAccount.billingInfo,
      //       clientFacingInfo: managedAccount.clientFacingInfo,
      //       sameAsBilling: managedAccount.sameAsBilling,
      //     };
      //   });
      //   setExtraItemOrder(managedAccount.extraItemOrder);
      //   setRemainingItemOrder(managedAccount.remainingItemOrder);
      //   setFormLoading(false);
      //   setStripeControlsEnabled(!isSubUserAccount);
      //   setIsSubUserAccount(isSubUserAccount);
      //   setAccountIsAdmin(accountIsAdmin);
      //   setAccountIsOwner(accountIsOwner);
      //   setCanEditSharedSettings(accountIsAdmin);
      //   setManagedAccountIdState(managedAccountId);
      //   setHistoryLoading(true);
      // // } else {
      // //   setFormLoading(false);
      // //   setHistoryLoading(false);
      // //   return;
      // // }

      const profile = await getCrispProfile(accountId);

      if (profile) {
        Crisp.user.setEmail(profile.email);
        Crisp.user.setNickname(`${profile.person.nickname}`);
      }

      const last4 = await getLastDigits(accountId);

      const billingRes = await getCustomerBillingHistory(accountId);

      if (
        last4 &&
        last4.error &&
        last4.error.response &&
        last4.error.response.data &&
        last4.error.response.data.error &&
        last4.error.response.data.error.includes('No such customer')
      ) {
        setLastFourError(true);
      }

      let items: BillingItem[] = [];
      if (
        billingRes &&
        billingRes.error &&
        billingRes.error.response &&
        billingRes.error.response.data &&
        billingRes.error.response.data.error &&
        billingRes.error.response.data.error.includes('No such customer')
      ) {
        setHistoryItemsError(true);
      } else {
        items = (Array.isArray(billingRes) ? billingRes : []).map((i: any) => ({
          amount: i.amount,
          date: new Date(i.date),
          description: i.description,
          method: i.source,
          receiptUrl: i.receiptUrl,
        }));
      }

      setHistoryItems(items);
      setHistoryLoading(false);
      setLast4(last4);

      await loadCurrentPlanInfo();
      await loadCurrentPlanLimits();
      await loadSeatUsageSummary();
      const fetchCustomerSecret = async () => {
        if (customerId && !isSubUserAccount) {
          try {
            const secret = await createCustomerSession(customerId);
            console.log(secret);

            setCustomerSecret(secret.client_secret);
          } catch (error) {
            console.error('Error creating customer session:', error);
          }
        }
      };

      fetchCustomerSecret();

      const scriptId = 'stripe-pricing-table-js';

      if (!isSubUserAccount && !document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://js.stripe.com/v3/pricing-table.js';
        script.async = true;
        document.body.appendChild(script);
      }

      handleLoading(false);
    };

    initialFunction();
  }, []);

  useEffect(() => {
    const nextValue = checkGate('more_orders');
    setShowMoreOrdersButton((prev) => (prev !== nextValue ? nextValue : prev));
  });

  useEffect(() => {
    return () => {
      if (gatePollIntervalId.current !== undefined) {
        window.clearInterval(gatePollIntervalId.current);
        gatePollIntervalId.current = undefined;
      }
      detachResizeObserver();
    };
  }, []);
  // ### END OF USE EFFECTS ###
  // ### CONSTANTS ###
  // const browser = detect();
  const isCanceled = currentPlanInfo && currentPlanInfo.cancelAtPeriodEnd ? true : false;
  const sharedSettingsReadOnly = !canEditSharedSettings;
  const sharedSettingsControlsDisabled = formLoading || sharedSettingsReadOnly;
  // const clientFacingSettingsReadOnly = sharedSettingsReadOnly || formFields.sameAsBilling;
  // const clientFacingControlsDisabled = formLoading || clientFacingSettingsReadOnly;
  const membershipActionsDisabled =
    historyLoading || !stripeControlsEnabled || planInfoError || historyItemsError || lastFourError;

  const businessInfoTabProps = {
    activeTab: activeTab === 0,
    loading: loading,
    disabled: loading || !canEditSharedSettings || sharedSettingsControlsDisabled,
    accountId: accountId,
    formFields: formFields,
    accountIsOwner: accountIsOwner,
    accountIsAdmin: accountIsAdmin,
    handleRefetchAccount: props.handleRefetchAccount,
  };

  const quipaSubscriptionTabProps = {
    activeTab: activeTab === 1,
    loading: loading,
    disabled: loading || !canEditSharedSettings || membershipActionsDisabled,
    accountId: accountId,
    seatUsageAvailable: seatUsageAvailable || 0,
    showBuyMoreOrders: !!(
      showMoreOrdersButton &&
      !planLimitLoading &&
      planLimitInfo &&
      planLimitInfo?.orderLimit !== undefined
    ),
    showCancelMembership:
      stripeControlsEnabled && localStorage.getItem('status') === 'subscribed' && !isCanceled,
    currentPlanInfo: currentPlanInfo,
    planLimitInfo: planLimitInfo,
    planInterval: planInterval,
    seatUsageUsed: seatUsageUsed,
    seatUsagePending: seatUsagePending,
    errorOrderLimit: errorOrderLimit,
    remainingItemOrder: remainingItemOrder,
    extraItemOrder: extraItemOrder,
    planLimitLoading: planLimitLoading,
    last4: last4,
    historyItems: historyItems,
    attachResizeObserver: attachResizeObserver,
    scrollToSection: scrollToSection,
    customerSecret: customerSecret,
    sectionRef: sectionRef,
    hostRef: hostRef,
  };

  // Uncomment when needed to implement
  // const invoiceAndEstimateTabProps = {
  //   activeTab: activeTab === 2,
  //   loading: loading,
  //   disabled: loading || !canEditSharedSettings,
  //   accountId: accountId,
  //   accountIsOwner: accountIsOwner,
  //   accountIsAdmin: accountIsAdmin,
  // };

  const estimateProps = {
    activeTab: activeTab === 2,
    loading: loading,
    disabled: loading || !canEditSharedSettings,
    accountId: accountId,
    accountIsOwner: accountIsOwner,
    accountIsAdmin: accountIsAdmin,
    formFields: formFields,
    estimateFields: estimateFields,
    handleRefetchAccount: props.handleRefetchAccount,
    handleActivateTab: handleActivateTab,
  };

  const descriptionSettingsProps = {
    activeTab: activeTab === 3,
    loading: loading,
    disabled: loading || !canEditSharedSettings,
    accountId: accountId,
    accountIsOwner: accountIsOwner,
    accountIsAdmin: accountIsAdmin,
    descriptionSettings: descriptionSettings,
    handleRefetchAccount: props.handleRefetchAccount,
  };
  // ### END OF CONSTANTS ###
  // ### RENDER JSX ###
  return (
    <div className="flex-1 overflow-auto p-4 md:p-8">
      <div className="max-w-[1024px] space-y-6">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold text-foreground m-0">Account Settings</h1>

          {!accountIsOwner && !accountIsAdmin && (
            <div className="rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 flex items-center gap-1">
              <LucideEye className="lucide lucide-eye h-[12px] w-[12px]" />
              Read-Only
            </div>
          )}
        </div>

        {loading ? (
          <Loader className="fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" />
        ) : (
          <>
            {/* Tabs Mobile */}
            <div className="flex md:hidden gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-none">
              <button
                data-selected={activeTab === 0}
                data-qa={`account_settings_business_info_tab_mobile`}
                onClick={() => handleActivateTab(0)}
                type="button"
                className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
              >
                <LucideBuilding2 className="lucide lucide-building2 h-[16px] w-[16px] shrink-0" />
                Business Info
              </button>

              {accountIsOwner && (
                <button
                  data-selected={activeTab === 1}
                  data-qa={`account_settings_quipa_subscription_tab_mobile`}
                  onClick={() => handleActivateTab(1)}
                  type="button"
                  className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
                >
                  <LucideCreditCard className="lucide lucide-credit-card h-[16px] w-[16px] shrink-0" />
                  QUIPA Subscription
                </button>
              )}

              <button
                data-selected={activeTab === 2}
                data-qa={`account_settings_invoice_and_estimate_tab_mobile`}
                onClick={() => handleActivateTab(2)}
                type="button"
                className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
              >
                <LucideFileText className="lucide lucide-file-text h-[16px] w-[16px] shrink-0" />
                Estimate
              </button>

              <button
                data-selected={activeTab === 3}
                data-qa={`account_settings_description_settings_tab_mobile`}
                onClick={() => handleActivateTab(3)}
                type="button"
                className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
              >
                <LucideListChecks className="lucide lucide-list-checks h-[16px] w-[16px] shrink-0" />
                Description Settings
              </button>
            </div>

            {/* Desktop */}
            <div className="flex flex-col md:flex-row gap-6">
              <nav className="hidden md:flex flex-col w-48 shrink-0 space-y-1">
                <button
                  data-selected={activeTab === 0}
                  data-qa={`account_settings_business_info_tab_mobile`}
                  onClick={() => handleActivateTab(0)}
                  type="button"
                  className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
                >
                  <LucideBuilding2 className="lucide lucide-building2 h-[16px] w-[16px] shrink-0" />
                  Business Info
                </button>

                {accountIsOwner && (
                  <button
                    data-selected={activeTab === 1}
                    data-qa={`account_settings_quipa_subscription_tab_mobile`}
                    onClick={() => handleActivateTab(1)}
                    type="button"
                    className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
                  >
                    <LucideCreditCard className="lucide lucide-credit-card h-[16px] w-[16px] shrink-0" />
                    QUIPA Subscription
                  </button>
                )}

                <button
                  data-selected={activeTab === 2}
                  data-qa={`account_settings_invoice_and_estimate_tab_mobile`}
                  onClick={() => handleActivateTab(2)}
                  type="button"
                  className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
                >
                  <LucideFileText className="lucide lucide-file-text h-[16px] w-[16px] shrink-0" />
                  Estimate
                </button>

                <button
                  data-selected={activeTab === 3}
                  data-qa={`account_settings_description_settings_tab_mobile`}
                  onClick={() => handleActivateTab(3)}
                  type="button"
                  className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap shrink-0 data-[selected=true]:bg-primary/10 data-[selected=true]:text-primary data-[selected=false]:text-muted-foreground data-[selected=false]:hover:bg-muted data-[selected=false]:hover:text-foreground min-h-[36px]"
                >
                  <LucideListChecks className="lucide lucide-list-checks h-[16px] w-[16px] shrink-0" />
                  Description Settings
                </button>
              </nav>

              <div className="flex-1 min-w-0">
                <BusinessInfo {...businessInfoTabProps} />
                <QuipaSubscription {...quipaSubscriptionTabProps} />
                {/* Uncomment when needed to implement */}
                {/* <InvoiceAndEstimate {...invoiceAndEstimateTabProps} /> */}
                <Estimate {...estimateProps} />
                <DescriptionSettings {...descriptionSettingsProps} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// export class AccountSettings extends PureComponent<
//   AccountSettingsProps & DispatchProp & RouteComponentProps,
//   State
// > {
//   private sectionRef = createRef<HTMLDivElement>();
//   private hostRef = createRef<HTMLElement>(); // <stripe-pricing-table> host
//   private resizeObserver?: any;
//   private gatePollIntervalId?: number;
//   public constructor(props: AccountSettingsProps & DispatchProp & RouteComponentProps) {
//     super(props);

//     this.state = {
//       historyItems: [],
//       last4: '',
//       plans: [],
//       formLoading: true,
//       historyLoading: true,
//       billingHistoryModalActive: false,
//       creditCardModalActive: false,
//       changePlanModalActive: false,
//       formFields: defaultFieldValues(),
//       imageModalOpen: false,
//       estimateNotes: '',
//       isCancellationModalOpen: false,
//       updateCardError: '',
//       planInfoError: false,
//       lastFourError: false,
//       historyItemsError: false,
//       isCancellationMembership: false,
//       currentPlanInfo: undefined,
//       planLimitInfo: {
//         orderLimit: undefined,
//         orderLimitLeft: undefined,
//       },
//       extraItemOrder: 0,
//       remainingItemOrder: 0,
//       planInterval: undefined,
//       errorOrderLimit: false,
//       planLimitLoading: false,
//       customerSecret: null,
//       buyMoreOrders: false,
//       showMoreOrdersButton: undefined,
//       stripeControlsEnabled: true,
//       isSubUserAccount: false,
//       accountIsAdmin: false,
//       accountIsOwner: false,
//       canEditSharedSettings: false,
//       managedAccountId: props.accountId,
//       seatUsageUsed: 0,
//       seatUsageAvailable: 0,
//       seatUsagePending: 0,
//     };
//   }

//   // REFACTORED
//   public async componentDidMount(): Promise<void> {
//     const showMoreOrdersButton = checkGate('more_orders');
//     this.setState({ showMoreOrdersButton });
//     this.gatePollIntervalId = window.setInterval(() => {
//       const nextShowMoreOrdersButton = checkGate('more_orders');
//       if (this.state.showMoreOrdersButton !== nextShowMoreOrdersButton) {
//         this.setState({
//           showMoreOrdersButton: nextShowMoreOrdersButton,
//         });
//       }

//       if ((window as any).statsigClient && this.gatePollIntervalId !== undefined) {
//         window.clearInterval(this.gatePollIntervalId);
//         this.gatePollIntervalId = undefined;
//       }
//     }, 500);

//     const { accountId } = this.props;
//     if (!localStorage.getItem(`login-event-${accountId}`)) {
//       localStorage.setItem(`login-event-${accountId}`, 'login' + Math.random());
//     }
//     // const accountId = parseFloat(localStorage.getItem("accountId") || "0");
//     const customerId = localStorage.getItem('customerId') || '';
//     // Track View with Mixpanel
//     trackView(MixpanelEvents.ACCOUNT_SETTINGS, {});
//     // End of code for Track View with Mixpanel

//     seedItemsOnLogin();

//     let isSubUserAccount = false;
//     let accountIsOwner = false;
//     let accountIsAdmin = false;
//     let managedAccountId = accountId;
//     let managedAccount = await getAccount(accountId);
//     if (managedAccount && !managedAccount.error) {
//       const parentAccountId = Number(managedAccount.parentAccountId);
//       accountIsOwner = !!managedAccount.isOwner;
//       accountIsAdmin = !!managedAccount.isAdmin || accountIsOwner;
//       isSubUserAccount = !accountIsOwner && Number.isFinite(parentAccountId) && parentAccountId > 0;
//       managedAccountId = isSubUserAccount ? parentAccountId : accountId;

//       if (managedAccountId !== accountId) {
//         const parentAccount = await getAccount(managedAccountId);
//         if (!parentAccount || parentAccount.error) {
//           this.setState({
//             formLoading: false,
//             historyLoading: false,
//             stripeControlsEnabled: false,
//             isSubUserAccount,
//             accountIsAdmin,
//             accountIsOwner,
//             canEditSharedSettings: accountIsAdmin,
//             managedAccountId,
//           });
//           return;
//         }
//         managedAccount = parentAccount;
//       }

//       this.setState({
//         formFields: {
//           avatarId: managedAccount.avatarId,
//           billingInfo: managedAccount.billingInfo,
//           clientFacingInfo: managedAccount.clientFacingInfo,
//           sameAsBilling: managedAccount.sameAsBilling,
//         },
//         extraItemOrder: managedAccount.extraItemOrder,
//         remainingItemOrder: managedAccount.remainingItemOrder,
//         formLoading: false,
//         stripeControlsEnabled: !isSubUserAccount,
//         isSubUserAccount,
//         accountIsAdmin,
//         accountIsOwner,
//         canEditSharedSettings: accountIsAdmin,
//         managedAccountId,
//         historyLoading: true,
//       });
//     } else {
//       this.setState({
//         formLoading: false,
//         historyLoading: false,
//       });
//       return;
//     }

//     const profile = await getCrispProfile(managedAccountId);

//     if (profile) {
//       Crisp.user.setEmail(profile.email);
//       Crisp.user.setNickname(`${profile.person.nickname}`);
//     }

//     const last4 = await getLastDigits(managedAccountId);

//     const billingRes = await getCustomerBillingHistory(managedAccountId);

//     if (
//       last4 &&
//       last4.error &&
//       last4.error.response &&
//       last4.error.response.data &&
//       last4.error.response.data.error &&
//       last4.error.response.data.error.includes('No such customer')
//     ) {
//       this.setState({ lastFourError: true });
//     }

//     let items: BillingItem[] = [];
//     if (
//       billingRes &&
//       billingRes.error &&
//       billingRes.error.response &&
//       billingRes.error.response.data &&
//       billingRes.error.response.data.error &&
//       billingRes.error.response.data.error.includes('No such customer')
//     ) {
//       this.setState({
//         historyItemsError: true,
//       });
//     } else {
//       items = (Array.isArray(billingRes) ? billingRes : []).map((i: any) => ({
//         amount: i.amount,
//         date: new Date(i.date),
//         description: i.description,
//         method: i.source,
//         receiptUrl: i.receiptUrl,
//       }));
//     }

//     this.setState({
//       historyItems: items,
//       historyLoading: false,
//       last4: last4,
//     });

//     await this.loadCurrentPlanInfo();
//     await this.loadCurrentPlanLimits();
//     await this.loadSeatUsageSummary();
//     const fetchCustomerSecret = async () => {
//       if (customerId && !isSubUserAccount) {
//         try {
//           const secret = await createCustomerSession(customerId);
//           console.log(secret);

//           this.setState({ customerSecret: secret.client_secret });
//         } catch (error) {
//           console.error('Error creating customer session:', error);
//         }
//       }
//     };

//     fetchCustomerSecret();

//     const scriptId = 'stripe-pricing-table-js';

//     if (!isSubUserAccount && !document.getElementById(scriptId)) {
//       const script = document.createElement('script');
//       script.id = scriptId;
//       script.src = 'https://js.stripe.com/v3/pricing-table.js';
//       script.async = true;
//       document.body.appendChild(script);
//     }
//   }
//   // REFACTORED
//   @Bind()
//   public componentDidUpdate(
//     prevProps: Readonly<AccountSettingsProps & DispatchProp & RouteComponentProps>,
//     prevState: Readonly<State>,
//     snapshot?: any
//   ) {
//     const showMoreOrdersButton = checkGate('more_orders');
//     if (prevState.showMoreOrdersButton !== showMoreOrdersButton) {
//       this.setState({ showMoreOrdersButton });
//     }

//     if (!prevState.buyMoreOrders && this.state.buyMoreOrders) {
//       this.attachResizeObserver();
//       this.scrollToSection({ smooth: true });
//     }
//   }
//   // REFACTORED
//   @Bind()
//   componentWillUnmount() {
//     if (this.gatePollIntervalId !== undefined) {
//       window.clearInterval(this.gatePollIntervalId);
//       this.gatePollIntervalId = undefined;
//     }
//     this.detachResizeObserver();
//   }
//   // REFACTORED
//   @Bind()
//   private attachResizeObserver() {
//     this.detachResizeObserver();

//     const host = this.hostRef.current;
//     if (!host || typeof (window as any).ResizeObserver === 'undefined') return;

//     this.resizeObserver = new (window as any).ResizeObserver((entries: any) => {
//       const entry = entries[0];
//       if (!entry) return;
//     });

//     this.resizeObserver && this.resizeObserver.observe(host);
//   }
//   // REFACTORED
//   @Bind()
//   private detachResizeObserver() {
//     if (this.resizeObserver) {
//       this.resizeObserver.disconnect();
//       this.resizeObserver = undefined;
//     }
//   }
//   // REFACTORED
//   @Bind()
//   scrollToSection(opts?: { smooth?: boolean; headerOffset?: number }) {
//     const el = this.sectionRef.current;
//     if (!el) return;
//     const behavior: ScrollBehavior = opts && opts.smooth ? 'smooth' : 'auto';
//     const headerOffset = opts && opts.headerOffset ? opts.headerOffset : 0;

//     const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

//     window.scrollTo({ top, behavior });
//   }
//   // REFACTORED
//   // private getManagedAccountId(): number {
//   //   return this.state.managedAccountId || this.props.accountId;
//   // }

//   private isSharedSettingsReadOnly(): boolean {
//     return !this.state.canEditSharedSettings;
//   }

//   private isClientFacingSettingsReadOnly(): boolean {
//     return this.isSharedSettingsReadOnly() || this.state.formFields.sameAsBilling;
//   }

//   public render(): JSX.Element {
//     // const browser = detect();
//     // const {
//     //   creditCardModalActive,
//     //   billingHistoryModalActive,
//     //   changePlanModalActive,
//     //   formFields,
//     //   formLoading,
//     //   last4,
//     //   historyItems,
//     //   historyLoading,
//     //   isCancellationModalOpen,
//     //   isCancellationMembership,
//     //   currentPlanInfo,
//     //   planInfoError,
//     //   lastFourError,
//     //   historyItemsError,
//     //   plans,
//     //   planLimitInfo,
//     //   planInterval,
//     //   errorOrderLimit,
//     //   planLimitLoading,
//     //   showMoreOrdersButton,
//     //   stripeControlsEnabled,
//     //   isSubUserAccount,
//     //   canEditSharedSettings,
//     //   managedAccountId,
//     //   seatUsageUsed,
//     //   seatUsageAvailable,
//     //   seatUsagePending,
//     // } = this.state;

//     // const { cardDigits } = this.props;
//     // const monthlyPrice =
//     //   currentPlanInfo && currentPlanInfo.monthlyPrice ? currentPlanInfo.monthlyPrice : 0;

//     // const discountAmount =
//     //   currentPlanInfo && currentPlanInfo.discountAmount ? currentPlanInfo.discountAmount : 0;
//     // const isCanceled = currentPlanInfo && currentPlanInfo.cancelAtPeriodEnd ? true : false;
//     // const currentPlan = currentPlanInfo ? currentPlanInfo.planType : undefined;
//     // const planName = currentPlanInfo ? currentPlanInfo.planName : '';
//     // let currentPath;
//     // if (typeof window !== 'undefined') {
//     //   currentPath = window.location.href;
//     // } else {
//     //   console.log('Not in a browser environment, unable to access window.location');
//     // }
//     // const baseUrl = currentPath && currentPath.replace(/\/account_settings$/, '');

//     // let stripeKey = 'pk_test_1SiljWdVwCkxpoBGYxDSagtF';

//     // if (baseUrl === 'https://dev.quipa.com') {
//     //   stripeKey = 'pk_test_1SiljWdVwCkxpoBGYxDSagtF';
//     // }

//     // if (baseUrl === 'https://staging.quipa.com') {
//     //   stripeKey = 'pk_test_1SiljWdVwCkxpoBGYxDSagtF';
//     // }

//     // if (baseUrl === 'https://my.quipa.com') {
//     //   stripeKey = 'pk_live_Ma3R4qIDnTMFj6ly1RQA1Nyi';
//     // }

//     // const remaining_orders_left =
//     //   planLimitInfo &&
//     //   planLimitInfo.orderLimit !== undefined &&
//     //   planLimitInfo.orderLimitLeft !== undefined
//     //     ? planLimitInfo.orderLimit - planLimitInfo.orderLimitLeft
//     //     : undefined;
//     // const sharedSettingsReadOnly = !canEditSharedSettings;
//     // const sharedSettingsInputsDisabled = formLoading;
//     // const sharedSettingsControlsDisabled = formLoading || sharedSettingsReadOnly;
//     // const clientFacingSettingsReadOnly = sharedSettingsReadOnly || formFields.sameAsBilling;
//     // const clientFacingInputsDisabled = formLoading;
//     // const clientFacingControlsDisabled = formLoading || clientFacingSettingsReadOnly;
//     // const membershipActionsDisabled =
//     //   historyLoading ||
//     //   !stripeControlsEnabled ||
//     //   planInfoError ||
//     //   historyItemsError ||
//     //   lastFourError;

//     // ### RENDER JSX ###
//     return <></>;
//     // OLD ACCOUNT SETTINGS
//     // return (
//     //   <PageContent>
//     //     <FadeLoader
//     //       style={{
//     //         position: 'absolute',
//     //         top: '50%',
//     //         left: '50%',
//     //         transform: 'translate(50%,-50%)',
//     //         zIndex: 9999,
//     //         display: formLoading ? 'block' : 'none',
//     //       }}
//     //       color="#3B97B1"
//     //       aria-label="Loading Spinner"
//     //       data-testid="loader"
//     //     />
//     //     <PageHeader classNameProps="font-24 mt-0" title="Account Settings" />
//     //     <ContentSection>
//     //       <SubContentSection>
//     //         <VSpace uiHeight="20px" />
//     //         {!formLoading && isSubUserAccount && (
//     //           <>
//     //             <HContainer>
//     //               <Content>
//     //                 {canEditSharedSettings
//     //                   ? 'These account settings are shared across your workspace. Changes here update the owner account for everyone.'
//     //                   : 'These account settings mirror your workspace owner. Only admins can make changes.'}
//     //               </Content>
//     //             </HContainer>
//     //             <VSpace uiHeight="20px" />
//     //           </>
//     //         )}

//     //         <Form
//     //           uiOnSubmit={this.handleSubmitForm}
//     //           uiReportValidityMode="firstInvalid"
//     //           onKeyPress={this.handleKeyPressForm}
//     //           uiPadding={false}
//     //           id="mainAccountSettingsForm"
//     //         >
//     //           <DisableAutocompleteInput name="firstName" />

//     //           <HContainer>
//     //             <VContainer uiFlex="1" uiMinWidth="225px" style={{ marginLeft: '10px' }}>
//     //               <div
//     //                 style={{
//     //                   display: 'flex',
//     //                   borderBottom: '1px solid #E2E2E2',
//     //                   justifyContent: 'space-between',
//     //                   alignItems: 'center',
//     //                   width: '100%',
//     //                 }}
//     //               >
//     //                 <FormSubtitle>COMPANY LOGO</FormSubtitle>
//     //                 {canEditSharedSettings && (
//     //                   <div>
//     //                     <div
//     //                       style={{
//     //                         display: 'flex',
//     //                         alignItems: 'center',
//     //                       }}
//     //                     >
//     //                       <div onClick={this.openAvatarModal}>
//     //                         <PencilEdit />
//     //                       </div>
//     //                       {formFields.avatarId && (
//     //                         <>
//     //                           <GrayBorder />
//     //                           <div
//     //                             style={{
//     //                               display: 'flex',
//     //                               alignItems: 'center',
//     //                             }}
//     //                             onClick={this.deleteAvatarImage}
//     //                           >
//     //                             <TrashDelete />
//     //                           </div>
//     //                         </>
//     //                       )}
//     //                     </div>
//     //                   </div>
//     //                 )}
//     //               </div>
//     //               <div
//     //                 style={{
//     //                   display: 'flex',
//     //                   marginTop: '12px',
//     //                   marginBottom: '12px',
//     //                   justifyContent: 'space-between',
//     //                   alignItems: 'left',
//     //                   width: '100%',
//     //                   fontSize: '12px',
//     //                   color: '#6B6B6B',
//     //                 }}
//     //               >
//     //                 <p>( will be used on the PDF, invoices, etc... )</p>
//     //               </div>
//     //               <AvatarContainer>
//     //                 <AccountAvatar
//     //                   avatarId={formFields.avatarId}
//     //                   openAvatarModal={this.openAvatarModal}
//     //                   deleteAvatarImage={this.deleteAvatarImage}
//     //                   isSquareImgHolder={false}
//     //                 />
//     //                 <AvatarActionContainer></AvatarActionContainer>
//     //               </AvatarContainer>
//     //             </VContainer>
//     //             <HSpace uiWidth="20px" />
//     //             <HBorder uiWidth="1px" uiBorderColor="#3b97b1" />
//     //             <HSpace uiWidth="20px" />

//     //             <VContainer uiFlex="1" uiMinWidth="225px">
//     //               <FormSubtitle>BILLING INFORMATION</FormSubtitle>

//     //               <VSpace uiHeight="41px" />

//     //               <FormLabel htmlFor="companyName">
//     //                 Company Name
//     //                 <span className="red-asterisk">*</span>
//     //               </FormLabel>
//     //               <FormInput
//     //                 id="companyName"
//     //                 name="billingInfo.companyName"
//     //                 className="label"
//     //                 type="text"
//     //                 required
//     //                 value={formFields.billingInfo.companyName || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={sharedSettingsReadOnly}
//     //                 aria-readonly={sharedSettingsReadOnly}
//     //                 disabled={sharedSettingsInputsDisabled}
//     //                 uiDisabled={sharedSettingsInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="address">Address</FormLabel>
//     //               <FormInput
//     //                 id="address"
//     //                 name="billingInfo.address"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.billingInfo.address || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={sharedSettingsReadOnly}
//     //                 aria-readonly={sharedSettingsReadOnly}
//     //                 disabled={sharedSettingsInputsDisabled}
//     //                 uiDisabled={sharedSettingsInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="unitSuite">Suite / Unit</FormLabel>
//     //               <FormInput
//     //                 id="unitSuite"
//     //                 name="billingInfo.unitSuite"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.billingInfo.unitSuite || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={sharedSettingsReadOnly}
//     //                 aria-readonly={sharedSettingsReadOnly}
//     //                 disabled={sharedSettingsInputsDisabled}
//     //                 uiDisabled={sharedSettingsInputsDisabled}
//     //               />

//     //               <VContainer>
//     //                 <FormLabel htmlFor="city">City</FormLabel>
//     //                 <FormInput
//     //                   id="city"
//     //                   name="billingInfo.city"
//     //                   className="label"
//     //                   type="text"
//     //                   value={formFields.billingInfo.city || ''}
//     //                   onChange={this.handleFieldChange}
//     //                   uiReportOnBlur={false}
//     //                   autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                   list="autocompleteOff"
//     //                   readOnly={sharedSettingsReadOnly}
//     //                   aria-readonly={sharedSettingsReadOnly}
//     //                   disabled={sharedSettingsInputsDisabled}
//     //                   uiDisabled={sharedSettingsInputsDisabled}
//     //                 />
//     //               </VContainer>

//     //               <HContainer>
//     //                 <VContainer uiFlex="1">
//     //                   <SelectList
//     //                     label={'State'}
//     //                     // tslint:disable-next-line:max-line-length
//     //                     selectList={[
//     //                       'AL',
//     //                       'AK',
//     //                       'AZ',
//     //                       'AR',
//     //                       'CA',
//     //                       'CO',
//     //                       'CT',
//     //                       'DE',
//     //                       'DC',
//     //                       'DR',
//     //                       'FL',
//     //                       'GA',
//     //                       'HI',
//     //                       'ID',
//     //                       'IL',
//     //                       'IN',
//     //                       'IA',
//     //                       'KS',
//     //                       'KY',
//     //                       'LA',
//     //                       'ME',
//     //                       'MT',
//     //                       'NE',
//     //                       'NV',
//     //                       'NH',
//     //                       'NJ',
//     //                       'NM',
//     //                       'NY',
//     //                       'NC',
//     //                       'ND',
//     //                       'OH',
//     //                       'OK',
//     //                       'OR',
//     //                       'MD',
//     //                       'MA',
//     //                       'MI',
//     //                       'MN',
//     //                       'MS',
//     //                       'MO',
//     //                       'PA',
//     //                       'RI',
//     //                       'SC',
//     //                       'SD',
//     //                       'TN',
//     //                       'TX',
//     //                       'UT',
//     //                       'VT',
//     //                       'VA',
//     //                       'WA',
//     //                       'WV',
//     //                       'WI',
//     //                       'WY',
//     //                     ]}
//     //                     handleClickSelect={this.handleFieldState}
//     //                     handleChangeCustomState={this.handleChangeCustomState}
//     //                     valueSelect={formFields.billingInfo.state}
//     //                     flexDirection={'column'}
//     //                     name="billingInfo.state"
//     //                     smallPadding
//     //                     uiBorderColor="#3b97b1"
//     //                     customValue
//     //                     noAddButton
//     //                     noClearBox
//     //                     uiDropArrow
//     //                     paddingRight
//     //                     disabled={sharedSettingsControlsDisabled}
//     //                   />
//     //                 </VContainer>

//     //                 <HSpace uiWidth="10px" />

//     //                 <VContainer uiFlex="2">
//     //                   <FormLabel htmlFor="zipCode">Zip</FormLabel>
//     //                   <FormInput
//     //                     id="zipCode"
//     //                     name="billingInfo.zipCode"
//     //                     className="label"
//     //                     type="text"
//     //                     value={formFields.billingInfo.zipCode || ''}
//     //                     onChange={this.handleFieldChange}
//     //                     uiReportOnBlur={false}
//     //                     autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                     list="autocompleteOff"
//     //                     readOnly={sharedSettingsReadOnly}
//     //                     aria-readonly={sharedSettingsReadOnly}
//     //                     disabled={sharedSettingsInputsDisabled}
//     //                     uiDisabled={sharedSettingsInputsDisabled}
//     //                   />
//     //                 </VContainer>
//     //               </HContainer>

//     //               <FormLabel htmlFor="billingEmailOwner">
//     //                 Email
//     //                 <span className="red-asterisk">*</span>
//     //               </FormLabel>
//     //               <FormInput
//     //                 id="billingEmailOwner"
//     //                 name="billingInfo.email"
//     //                 className="label"
//     //                 type="email"
//     //                 required
//     //                 value={formFields.billingInfo.email || ''}
//     //                 pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={sharedSettingsReadOnly}
//     //                 aria-readonly={sharedSettingsReadOnly}
//     //                 disabled={sharedSettingsInputsDisabled}
//     //                 uiDisabled={sharedSettingsInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="billingPhone">
//     //                 Phone
//     //                 <span className="red-asterisk">*</span>
//     //               </FormLabel>
//     //               <FormInput
//     //                 id="billingPhone"
//     //                 name="billingInfo.phone"
//     //                 className="label"
//     //                 type="text"
//     //                 required
//     //                 value={formFields.billingInfo.phone || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={sharedSettingsReadOnly}
//     //                 aria-readonly={sharedSettingsReadOnly}
//     //                 disabled={sharedSettingsInputsDisabled}
//     //                 uiDisabled={sharedSettingsInputsDisabled}
//     //               />

//     //               <VSpace uiHeight="20px" />
//     //               {/* {
//     //                                 (planInfoError || historyItemsError || lastFourError) ? <HContainer className="text-red-500">Billing and client facing informations can't be changed until stripe issues are resolved.</HContainer> : ''
//     //                                 } */}
//     //             </VContainer>

//     //             <HSpace uiWidth="20px" />
//     //             <HBorder uiWidth="1px" uiBorderColor="#3b97b1" />
//     //             <HSpace uiWidth="20px" />

//     //             <VContainer uiFlex="1" uiMinWidth="225px">
//     //               <FormSubtitle>CLIENT FACING INFORMATION</FormSubtitle>

//     //               <BillingCheckBox
//     //                 id="sameAsBilling"
//     //                 name="sameAsBilling"
//     //                 checked={formFields.sameAsBilling}
//     //                 onChange={this.handleFieldChange}
//     //                 disabled={sharedSettingsControlsDisabled}
//     //                 uiDisabled={sharedSettingsControlsDisabled}
//     //               >
//     //                 Same as Billing
//     //               </BillingCheckBox>

//     //               <FormLabel htmlFor="companyName">
//     //                 Company Name
//     //                 <span className="red-asterisk">*</span>
//     //               </FormLabel>
//     //               <FormInput
//     //                 id="clientFacingCompanyName"
//     //                 name="clientFacingInfo.companyName"
//     //                 className="label"
//     //                 type="text"
//     //                 required
//     //                 value={formFields.clientFacingInfo.companyName || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="address">Address</FormLabel>
//     //               <FormInput
//     //                 id="clientFacingAddress"
//     //                 name="clientFacingInfo.address"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.clientFacingInfo.address || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="unitSuite">Suite / Unit</FormLabel>
//     //               <FormInput
//     //                 id="clientFacingUnitSuite"
//     //                 name="clientFacingInfo.unitSuite"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.clientFacingInfo.unitSuite || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="city">City</FormLabel>
//     //               <FormInput
//     //                 id="clientFacingCity"
//     //                 name="clientFacingInfo.city"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.clientFacingInfo.city || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <HContainer>
//     //                 <VContainer uiFlex="1">
//     //                   <SelectList
//     //                     label={'State'}
//     //                     selectList={[
//     //                       'AL',
//     //                       'AK',
//     //                       'AZ',
//     //                       'AR',
//     //                       'CA',
//     //                       'CO',
//     //                       'CT',
//     //                       'DE',
//     //                       'DC',
//     //                       'DR',
//     //                       'FL',
//     //                       'GA',
//     //                       'HI',
//     //                       'ID',
//     //                       'IL',
//     //                       'IN',
//     //                       'IA',
//     //                       'KS',
//     //                       'KY',
//     //                       'LA',
//     //                       'ME',
//     //                       'MT',
//     //                       'NE',
//     //                       'NV',
//     //                       'NH',
//     //                       'NJ',
//     //                       'NM',
//     //                       'NY',
//     //                       'NC',
//     //                       'ND',
//     //                       'OH',
//     //                       'OK',
//     //                       'OR',
//     //                       'MD',
//     //                       'MA',
//     //                       'MI',
//     //                       'MN',
//     //                       'MS',
//     //                       'MO',
//     //                       'PA',
//     //                       'RI',
//     //                       'SC',
//     //                       'SD',
//     //                       'TN',
//     //                       'TX',
//     //                       'UT',
//     //                       'VT',
//     //                       'VA',
//     //                       'WA',
//     //                       'WV',
//     //                       'WI',
//     //                       'WY',
//     //                     ]}
//     //                     handleClickSelect={this.handleFieldState}
//     //                     handleChangeCustomState={this.handleChangeCustomState}
//     //                     valueSelect={formFields.clientFacingInfo.state}
//     //                     flexDirection={'column'}
//     //                     name="clientFacingInfo.state"
//     //                     smallPadding
//     //                     uiBorderColor="#3b97b1"
//     //                     customValue
//     //                     noAddButton
//     //                     noClearBox
//     //                     uiDropArrow
//     //                     paddingRight
//     //                     disabled={clientFacingControlsDisabled}
//     //                     // uiDisabled={historyLoading || formFields.sameAsBilling || planInfoError || historyItemsError || lastFourError ? true : false}
//     //                   />
//     //                 </VContainer>

//     //                 <HSpace uiWidth="10px" />

//     //                 <VContainer uiFlex="2">
//     //                   <FormLabel htmlFor="zipCode">Zip</FormLabel>
//     //                   <FormInput
//     //                     id="clientFacingZipCode"
//     //                     name="clientFacingInfo.zipCode"
//     //                     className="label"
//     //                     type="number"
//     //                     value={formFields.clientFacingInfo.zipCode || ''}
//     //                     onChange={this.handleFieldChange}
//     //                     uiReportOnBlur={false}
//     //                     autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                     list="autocompleteOff"
//     //                     readOnly={clientFacingSettingsReadOnly}
//     //                     aria-readonly={clientFacingSettingsReadOnly}
//     //                     disabled={clientFacingInputsDisabled}
//     //                     uiDisabled={clientFacingInputsDisabled}
//     //                   />
//     //                 </VContainer>
//     //               </HContainer>

//     //               <FormLabel htmlFor="clientFacingEmailOwner">Email</FormLabel>
//     //               <FormInput
//     //                 id="clientFacingEmailOwner"
//     //                 name="clientFacingInfo.email"
//     //                 className="label"
//     //                 type="email"
//     //                 value={formFields.clientFacingInfo.email || ''}
//     //                 pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <FormLabel htmlFor="clientFacingPhone">Phone</FormLabel>
//     //               <FormInput
//     //                 id="clientFacingPhone"
//     //                 name="clientFacingInfo.phone"
//     //                 className="label"
//     //                 type="text"
//     //                 value={formFields.clientFacingInfo.phone || ''}
//     //                 onChange={this.handleFieldChange}
//     //                 uiReportOnBlur={false}
//     //                 autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
//     //                 list="autocompleteOff"
//     //                 readOnly={clientFacingSettingsReadOnly}
//     //                 aria-readonly={clientFacingSettingsReadOnly}
//     //                 disabled={clientFacingInputsDisabled}
//     //                 uiDisabled={clientFacingInputsDisabled}
//     //               />

//     //               <VSpace uiHeight="20px" />
//     //             </VContainer>
//     //           </HContainer>

//     //           <VSpace uiHeight="30px" />

//     //           {canEditSharedSettings && (
//     //             <HContainer>
//     //               <SaveButton
//     //                 uiColor="primary"
//     //                 type="submit"
//     //                 form="mainAccountSettingsForm"
//     //                 disabled={sharedSettingsControlsDisabled}
//     //                 uiDisabled={sharedSettingsControlsDisabled}
//     //               >
//     //                 Save
//     //               </SaveButton>
//     //             </HContainer>
//     //           )}
//     //         </Form>

//     //         <>
//     //           <VSpace uiHeight="40px" />
//     //           <VBorder uiHeight="20px" uiBorderColor="#e8f6fc" />
//     //           <VSpace uiHeight="40px" />

//     //           <ClientSettingsAdittionalForm>
//     //             <HContainer>
//     //               <VContainer uiFlex="1">
//     //                 <FormSubtitle>BILLING / MEMBERSHIP</FormSubtitle>
//     //                 {isSubUserAccount && (
//     //                   <>
//     //                     <Content>
//     //                       Billing and membership are managed on the owner account. The details below
//     //                       are shown for reference only.
//     //                     </Content>
//     //                     <VSpace uiHeight="10px" />
//     //                   </>
//     //                 )}
//     //                 <SubtitleWrapper>
//     //                   <Subtitle>ACCOUNT ID</Subtitle>
//     //                   <Content>{managedAccountId}</Content>
//     //                 </SubtitleWrapper>
//     //                 <VSpace uiHeight="10px" />

//     //                 <Subtitle>CURRENT PLAN</Subtitle>
//     //                 {!currentPlanInfo && !planInfoError && <Loader />}
//     //                 {currentPlanInfo && (
//     //                   <>
//     //                     <Content>{planName}</Content>
//     //                     <Content>
//     //                       {new Intl.NumberFormat('en-US', {
//     //                         style: 'currency',
//     //                         currency: 'USD',
//     //                         minimumFractionDigits: 2,
//     //                         maximumFractionDigits: 2,
//     //                       }).format((monthlyPrice - discountAmount) / 100)}{' '}
//     //                       {planInterval
//     //                         ? planInterval === 'month'
//     //                           ? `${planInterval}ly`
//     //                           : 'annually'
//     //                         : 'monthly'}
//     //                     </Content>
//     //                     <Content>
//     //                       {isCanceled || isCancellationMembership
//     //                         ? 'Membership Ends'
//     //                         : 'Renewal Date'}
//     //                       :{' '}
//     //                       {currentPlanInfo && currentPlanInfo.renewalDate
//     //                         ? moment(currentPlanInfo.renewalDate).format('MMMM DD, YYYY')
//     //                         : ''}
//     //                     </Content>
//     //                     {seatUsageAvailable > 0 && (
//     //                       <Content>
//     //                         {seatUsageUsed} of {seatUsageAvailable} seats used
//     //                         {seatUsagePending > 0 ? ` (includes ${seatUsagePending} pending)` : ''}
//     //                       </Content>
//     //                     )}

//     //                     <Content className="flex flex-wrap gap-2">
//     //                       {planLimitLoading ? (
//     //                         <Loader />
//     //                       ) : (
//     //                         <>
//     //                           <span>{`Item Orders (${
//     //                             errorOrderLimit
//     //                               ? 'Invalid duration'
//     //                               : planInterval === 'month'
//     //                                 ? `${planInterval}ly`
//     //                                 : 'annually'
//     //                           }):`}</span>
//     //                           <span>
//     //                             {errorOrderLimit
//     //                               ? 'Invalid remaining'
//     //                               : planLimitInfo && planLimitInfo.orderLimit === undefined
//     //                                 ? 'Unlimited'
//     //                                 : `${
//     //                                     remaining_orders_left && remaining_orders_left < 0
//     //                                       ? 0
//     //                                       : remaining_orders_left
//     //                                   } of ${planLimitInfo.orderLimit} remaining`}
//     //                           </span>
//     //                         </>
//     //                       )}
//     //                     </Content>
//     //                     <Content className="flex flex-wrap gap-2">
//     //                       {!planLimitLoading &&
//     //                         planLimitInfo &&
//     //                         planLimitInfo.orderLimit !== undefined && (
//     //                           <span>{`Extra Item Orders: ${
//     //                             this.state.remainingItemOrder !== undefined
//     //                               ? this.state.remainingItemOrder
//     //                               : 0
//     //                           } of ${this.state.extraItemOrder} remaining`}</span>
//     //                         )}
//     //                     </Content>

//     //                     <VSpace uiHeight="10px" />
//     //                     <SubtitleWrapper>
//     //                       {showMoreOrdersButton &&
//     //                         !planLimitLoading &&
//     //                         planLimitInfo &&
//     //                         planLimitInfo.orderLimit !== undefined && (
//     //                           <BuyMoreOrdersButton
//     //                             uiColor="primary"
//     //                             onClick={this.buyMoreOrders}
//     //                             disabled={membershipActionsDisabled}
//     //                           >
//     //                             Buy More Orders
//     //                           </BuyMoreOrdersButton>
//     //                         )}
//     //                       <ChangePlanButton
//     //                         style={{
//     //                           background:
//     //                             planLimitInfo.orderLimit !== undefined ? '#F1F5F9' : '#3b97b1',
//     //                           color: planLimitInfo.orderLimit !== undefined ? '#1B1C1D' : '#fff',
//     //                           marginLeft:
//     //                             planLimitInfo && planLimitInfo.orderLimit === undefined
//     //                               ? '0px'
//     //                               : '20px',
//     //                         }}
//     //                         uiColor={
//     //                           planLimitInfo && planLimitInfo.orderLimit === undefined
//     //                             ? 'primary'
//     //                             : 'secondary'
//     //                         }
//     //                         onClick={this.changeQuipaPlan}
//     //                         disabled={membershipActionsDisabled}
//     //                         uiDisabled={membershipActionsDisabled}
//     //                       >
//     //                         Change Plan
//     //                       </ChangePlanButton>
//     //                       {stripeControlsEnabled &&
//     //                         localStorage.getItem('status') === 'subscribed' &&
//     //                         !isCanceled &&
//     //                         !isCancellationMembership && (
//     //                           <BilllingCommentSpan onClick={this.openCancellationModal}>
//     //                             Cancel Membership
//     //                           </BilllingCommentSpan>
//     //                         )}
//     //                     </SubtitleWrapper>
//     //                     {this.state.buyMoreOrders && this.state.customerSecret && (
//     //                       <div ref={this.sectionRef} style={{ scrollMarginTop: 80 }}>
//     //                         <stripe-pricing-table
//     //                           ref={this.hostRef}
//     //                           pricing-table-id={Config.pricingTableBuyMoreOrdersId || null}
//     //                           publishable-key={Config.stripeBuyMoreOrdersPk}
//     //                           client-reference-id={this.getManagedAccountId()}
//     //                           customer-session-client-secret={this.state.customerSecret}
//     //                         ></stripe-pricing-table>
//     //                       </div>
//     //                     )}
//     //                   </>
//     //                 )}
//     //               </VContainer>

//     //               <HSpace uiWidth="20px" />
//     //               <HBorder uiWidth="1px" uiBorderColor="#3b97b1" />
//     //               <HSpace uiWidth="20px" />

//     //               <VContainer uiFlex="1">
//     //                 <SubtitleWrapper>
//     //                   {last4 && (
//     //                     <>
//     //                       <Subtitle>CURRENT CARD</Subtitle>
//     //                       <Content className="card">{`x${last4}`}</Content>
//     //                     </>
//     //                   )}
//     //                 </SubtitleWrapper>
//     //                 <VSpace uiHeight="10px" />
//     //                 <ChangePlanButton
//     //                   uiColor="primary"
//     //                   onClick={this.changeCreditCard}
//     //                   disabled={membershipActionsDisabled}
//     //                   uiDisabled={membershipActionsDisabled}
//     //                 >
//     //                   Change Card
//     //                 </ChangePlanButton>

//     //                 <Subtitle>PAYMENT HISTORY</Subtitle>
//     //                 {historyLoading && <Loader />}
//     //                 <BillingTable
//     //                   items={historyItems}
//     //                   loading={historyLoading}
//     //                   onOpenModal={this.openBillingHistoryModal}
//     //                 />
//     //               </VContainer>
//     //             </HContainer>
//     //           </ClientSettingsAdittionalForm>

//     //           <VSpace uiHeight="40px" />
//     //           <VBorder uiHeight="20px" uiBorderColor="#e8f6fc" />
//     //           <VSpace uiHeight="40px" />
//     //         </>

//     //         {/* <ClientSettingsAdittionalForm>
//     //                         <CustomizedForm
//     //                             uiOnSubmit={this.handleSubmitCustomizedForm}
//     //                             uiReportValidityMode="firstInvalid"
//     //                             uiPadding={false}
//     //                             id="customizedForm"
//     //                         >
//     //                             <HContainer>
//     //                                 <VContainer uiFlex="1">
//     //                                     <FormSubtitle>CUSTOMIZED FORMS</FormSubtitle>
//     //                                     <SubtitleWrapper>
//     //                                         <Subtitle>ESTIMATE NOTES</Subtitle>
//     //                                     </SubtitleWrapper>
//     //                                     <ClientSettingsTextArea
//     //                                         onChange={this.handleTextAreaChange}
//     //                                         value={this.state.estimateNotes}
//     //                                         placeholder="Appears in the notes section of all new Estimates."
//     //                                     />
//     //                                     <VSpace uiHeight="10px" />
//     //                                     <ChangePlanButton
//     //                                         type="submit"
//     //                                         form="customizedForm"
//     //                                         uiColor="primary"
//     //                                         onClick={this.handleSaveEstimateNote}
//     //                                     >
//     //                                         Save
//     //                                     </ChangePlanButton>
//     //                                 </VContainer>
//     //                             </HContainer>
//     //                         </CustomizedForm>
//     //                     </ClientSettingsAdittionalForm> */}

//     //         <VSpace uiHeight="10px" />
//     //         <VBorder uiHeight="2px" uiBorderColor="#e8f6fc" />
//     //         <VSpace uiHeight="10px" />

//     //         {false && (
//     //           <div>
//     //             {/* {userRole === "admin" && !quickbookConnected && ( */}
//     //             <Button
//     //               className="connect-to-quickBook"
//     //               uiFlat
//     //               uiColor={theme.colors.secondary}
//     //               onClick={this.handleQuickBooks}
//     //             >
//     //               Connect to QuickBooks
//     //             </Button>
//     //             {/* )} */}
//     //           </div>
//     //         )}
//     //       </SubContentSection>
//     //     </ContentSection>

//     //     <AvatarModal
//     //       uiActive={this.state.imageModalOpen}
//     //       uiOnRequestClose={this.closeAvatarModal}
//     //       onSave={this.saveAvatarImage}
//     //     />
//     //     <UpdateCreditCardModal
//     //       configKey={stripeKey}
//     //       onAddCard={this.updateCreditCard}
//     //       onRequestClose={this.closeCreditCardModal}
//     //       active={creditCardModalActive}
//     //       updateCardError={this.state.updateCardError}
//     //       onUpdateCardError={this.handleUpdateCardError}
//     //     />
//     //     <BillingHistoryModal
//     //       onRequestClose={this.closeBillingHistoryModal}
//     //       active={billingHistoryModalActive}
//     //       items={historyItems}
//     //     />
//     //     <ChangePlanModal
//     //       onRequestClose={this.closeChangePlanModal}
//     //       plans={plans}
//     //       currentPlan={currentPlan}
//     //       active={changePlanModalActive}
//     //       onChangePlan={this.changePlan}
//     //     />
//     //     <CancellationModal
//     //       active={isCancellationModalOpen}
//     //       onRequestClose={this.closeCancellationModal}
//     //       handleConfirmCancellation={this.handleConfirmCancellation}
//     //       accountId={this.getManagedAccountId()}
//     //     />
//     //   </PageContent>
//     // );
//   }

//   // @Bind()
//   // private openChangePlanModal(): void {
//   //     this.setState({
//   //         changePlanModalActive: true,
//   //     });
//   // }

//   // @Bind()
//   // private async changeQuipaPlan(): Promise<void> {
//   //   const accountId = this.getManagedAccountId();
//   //   const hasSeatsPlan = this.state.seatUsageAvailable > 0;
//   //   const useNewBillingPortal = hasSeatsPlan || checkGate(PRICING_TABLE_PLANS_GATE);
//   //   const variant = useNewBillingPortal ? 'new' : 'old';
//   //   const session = await changeSubscriptionPlan(accountId, variant);
//   //   window.location.href = session.url;
//   // }

//   // @Bind()
//   // private async buyMoreOrders(): Promise<void> {
//   //   // const { history } = this.props;
//   //   // const session = await buyExtraOrders(accountId);
//   //   // history.push('/buy_more_orders')
//   //   this.setState((prevState) => ({ buyMoreOrders: !prevState.buyMoreOrders }));
//   //   // location.href = '/buy_more_orders';
//   //   // window.location.href = session.url;
//   // }

//   // @Bind()
//   // private async changeCreditCard(): Promise<void> {
//   //   const accountId = this.getManagedAccountId();
//   //   const session = await changeCard(accountId);

//   //   window.location.href = session.url;
//   // }

//   // @Bind()
//   // private openBillingHistoryModal(): void {
//   //   this.setState({
//   //     billingHistoryModalActive: true,
//   //   });
//   // }

//   // @Bind()
//   // private openCancellationModal(): void {
//   //   this.setState({
//   //     isCancellationModalOpen: true,
//   //   });
//   // }

//   // @Bind()
//   // private closeCreditCardModal(): void {
//   //   this.setState({
//   //     creditCardModalActive: false,
//   //     updateCardError: '',
//   //   });
//   // }

//   // @Bind()
//   // private closeBillingHistoryModal(): void {
//   //   this.setState({
//   //     billingHistoryModalActive: false,
//   //   });
//   // }

//   // @Bind()
//   // private closeChangePlanModal(): void {
//   //   this.setState({
//   //     changePlanModalActive: false,
//   //   });
//   // }

//   // @Bind()
//   // private closeCancellationModal(): void {
//   //   this.setState({
//   //     isCancellationModalOpen: false,
//   //   });
//   // }

//   // @Bind()
//   // private async updateCreditCard(token: string): Promise<void> {
//   //   const accountId = this.getManagedAccountId();
//   //   try {
//   //     await updateStripePayment(accountId, token);
//   //     this.setState({
//   //       updateCardError: '',
//   //     });
//   //     window.location.reload();
//   //     return;
//   //   } catch (error: any) {
//   //     if (error.response && error.response.data && error.response.data.error) {
//   //       this.setState({
//   //         updateCardError: `${error.response.data.error}`,
//   //       });
//   //     } else {
//   //       this.setState({
//   //         updateCardError: `${error.message}`,
//   //       });
//   //     }
//   //   }
//   // }

//   // @Bind()
//   // private async changePlan(planType: string): Promise<void> {
//   //   const accountId = this.getManagedAccountId();

//   //   const res = await subscribeAccount({
//   //     id: accountId,
//   //     planType,
//   //   });
//   //   if (res.error) {
//   //     throw new Error(res.payload.message);
//   //   }
//   //   await this.loadCurrentPlanInfo();
//   //   this.setState({
//   //     changePlanModalActive: false,
//   //   });
//   // }

//   // REFACTORED
//   // private loadCurrentPlanInfo = async () => {
//   //   const accountId = this.getManagedAccountId();

//   //   const planInfoRes = await getCustomerPlanInfo(accountId);
//   //   let planInfo = planInfoRes['main'];
//   //   let planInfoSeat = planInfoRes['seat'];

//   //   if (
//   //     planInfo &&
//   //     planInfoRes &&
//   //     planInfoRes.error &&
//   //     planInfoRes.error.response &&
//   //     planInfoRes.error.response.data &&
//   //     planInfoRes.error.response.data.error &&
//   //     planInfoRes.error.response.data.error.includes('No such customer')
//   //   ) {
//   //     this.setState({
//   //       planInfoError: true,
//   //     });
//   //   } else {
//   //     const item_order =
//   //       planInfo && planInfo.product_metadata && planInfo.product_metadata.item_order
//   //         ? planInfo.product_metadata.item_order.toString()
//   //         : '';

//   //     const currentStore = localStorage.getItem('quipa-store');

//   //     let storeObj = currentStore ? JSON.parse(currentStore) : {};

//   //     storeObj.user = {
//   //       ...(storeObj.user || {}),
//   //       item_order,
//   //     };

//   //     localStorage.setItem('quipa-store', JSON.stringify(storeObj));

//   //     this.setState({
//   //       currentPlanInfo: {
//   //         planType: planInfo.object,
//   //         planName: planInfo.planName,
//   //         startDate: new Date(planInfo.current_period_start * 1000),
//   //         renewalDate: new Date(planInfo.current_period_end * 1000),
//   //         monthlyPrice: planInfo && planInfo.plan && planInfo.plan.amount,
//   //         planId: planInfo && planInfo.plan && planInfo.plan.id,
//   //         promoId: planInfo.discount && planInfo.discount.promotion_code,
//   //         cancelAtPeriodEnd: planInfo.canceled_at ? true : false,
//   //         discountAmount:
//   //           planInfo.discount &&
//   //           (planInfo.plan.amount * planInfo.discount.coupon.percent_off) / 100,
//   //       },
//   //       planInterval:
//   //         planInfo && planInfo.plan && planInfo.plan.interval ? planInfo.plan.interval : undefined,
//   //       seatUsageAvailable:
//   //         planInfo &&
//   //         planInfo.product_metadata &&
//   //         Number.isFinite(Number(planInfo.product_metadata.seats))
//   //           ? Math.max(Number(planInfo.product_metadata.seats) + (planInfoSeat?.quantity || 0), 0)
//   //           : 0,
//   //     });
//   //   }
//   // };
//   // REFACTORED
//   // private loadSeatUsageSummary = async () => {
//   //   const accountId = this.getManagedAccountId();

//   //   try {
//   //     const user = await getUser({ accountId, includeTeamData: true });
//   //     const teamMembers = Array.isArray(user?.teamContext?.teamMembers)
//   //       ? user.teamContext.teamMembers
//   //       : [];
//   //     const subscribedMembers = teamMembers.filter(
//   //       (member: any) => String(member?.type || '').toLowerCase() === 'subscribed'
//   //     );

//   //     const ownerExistsInTeam = subscribedMembers.some((member: any) => !!member?.isOwner);
//   //     const activeTeamMembersCount =
//   //       subscribedMembers.length > 0 ? subscribedMembers.length + (ownerExistsInTeam ? 0 : 1) : 1;

//   //     const pendingInvitations = Array.isArray(user?.teamContext?.pendingInvitations)
//   //       ? user.teamContext.pendingInvitations
//   //       : [];
//   //     const pendingCount = pendingInvitations.length;

//   //     this.setState({
//   //       seatUsagePending: pendingCount,
//   //       seatUsageUsed: activeTeamMembersCount + pendingCount,
//   //     });
//   //   } catch (error) {
//   //     // Seat usage line is supplemental; keep Account Settings usable on failures.
//   //   }
//   // };
//   // REFACTORED
//   // private loadCurrentPlanLimits = async () => {
//   //   const accountId = this.getManagedAccountId();

//   //   this.setState((prev) => ({ ...prev, planLimitLoading: true }));

//   //   const order_limit = await retrieveMetadata(accountId);

//   //   if (
//   //     order_limit &&
//   //     order_limit.error &&
//   //     order_limit.error.response &&
//   //     order_limit.error.response.data &&
//   //     order_limit.error.response.data.error &&
//   //     order_limit.error.response.data.error.includes('Not Found')
//   //   ) {
//   //     this.setState((prev) => {
//   //       return {
//   //         ...prev,
//   //         errorOrderLimit: true,
//   //       };
//   //     });
//   //   }

//   //   const order_limit_left = await getTotalNumberCount(accountId);

//   //   if (
//   //     (order_limit_left &&
//   //       order_limit_left.error &&
//   //       order_limit_left.error.response &&
//   //       order_limit_left.error.response.data &&
//   //       order_limit_left.error.response.data.error &&
//   //       order_limit_left.error.response.data.error.includes('Not Found')) ||
//   //     (order_limit_left &&
//   //       order_limit_left.response &&
//   //       order_limit_left.response.message &&
//   //       order_limit_left.response.message.includes('Subscription not found'))
//   //   ) {
//   //     this.setState((prev) => {
//   //       return {
//   //         ...prev,
//   //         errorOrderLimit: true,
//   //       };
//   //     });
//   //   }

//   //   if (!this.state.planInfoError) {
//   //     let order_limit_number: any = undefined;

//   //     if (order_limit && order_limit.item_order) {
//   //       order_limit_number = +order_limit.item_order;
//   //     }

//   //     this.setState((prev) => {
//   //       return {
//   //         ...prev,
//   //         planLimitInfo: {
//   //           orderLimit: order_limit_number,
//   //           orderLimitLeft: order_limit_left && !order_limit_left.error ? order_limit_left : 0,
//   //         },
//   //       };
//   //     });
//   //   }
//   //   this.setState((prev) => ({ ...prev, planLimitLoading: false }));
//   // };

//   // private handleUpdateCardError = (error: string) => {
//   //   this.setState({ updateCardError: error });
//   // };

//   // private openAvatarModal = () => {
//   //   if (this.isSharedSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   this.setState({
//   //     imageModalOpen: true,
//   //   });
//   // };

//   // private closeAvatarModal = () => {
//   //   this.setState({
//   //     imageModalOpen: false,
//   //   });
//   // };

//   // private handleQuickBooks = async () => {
//   //   const response = await quickbooksOauth(this.props.accountId, false);

//   //   console.log(response);

//   //   const { authUrl } = response;

//   //   sessionStorage.setItem('qbo_state', response.state);

//   //   console.log(authUrl);

//   //   if (authUrl) {
//   //     window.location.href = authUrl;
//   //   }
//   // };

//   // private saveAvatarImage = async (file: File) => {
//   //   if (this.isSharedSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   const accountId = this.getManagedAccountId();

//   //   const formData = new FormData();
//   //   formData.append('file', file);
//   //   formData.append('accountId', accountId.toString());
//   //   formData.append('fileStoreUrl', Config.fileStoreUrl);
//   //   const res = await uploadImage(formData);
//   //   if (res.error) {
//   //     throw new Error(res.message);
//   //   }

//   //   const res1 = await updateAccount({
//   //     accountId: this.props.accountId,
//   //     targetAccountId: accountId,
//   //     avatarId: res.url,
//   //   });

//   //   trackView(MixpanelEvents.UPLOAD_COMPANY_LOGO);

//   //   if (res1.error) {
//   //     if (res1.error && res1.message) {
//   //       //     const errors = (res1.payload as Error as ValidationError)
//   //       //         .errors;
//   //       //     throw FormValidationError.fromErrorDictionary(errors);
//   //       // } else {
//   //       throw new Error(res1.message);
//   //     }
//   //   } else {
//   //     this.setState({
//   //       formFields: {
//   //         ...this.state.formFields,
//   //         avatarId: res.url,
//   //       },
//   //       imageModalOpen: false,
//   //     });
//   //   }
//   // };

//   // private deleteAvatarImage = async () => {
//   //   if (this.isSharedSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   const accountId = this.getManagedAccountId();

//   //   const res = await updateAccount({
//   //     accountId: this.props.accountId,
//   //     targetAccountId: accountId,
//   //     avatarId: null,
//   //   });

//   //   if (res.error) {
//   //     if (res.message && res.error) {
//   //       //     const errors = (res.payload as Error as ValidationError).errors;
//   //       //     throw FormValidationError.fromErrorDictionary(errors);
//   //       // } else {
//   //       throw new Error(res.message);
//   //     }
//   //   } else {
//   //     this.setState({
//   //       formFields: {
//   //         ...this.state.formFields,
//   //         avatarId: null,
//   //       },
//   //     });
//   //   }
//   // };

//   // @Bind()
//   // private async handleFieldChange(e: ChangeEvent<HTMLInputElement>): Promise<void> {
//   //   const fieldName = e.currentTarget.name;

//   //   if (fieldName.startsWith('billingInfo.') && this.isSharedSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   if (fieldName.startsWith('clientFacingInfo.') && this.isClientFacingSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   if (fieldName === 'sameAsBilling' && this.isSharedSettingsReadOnly()) {
//   //     return;
//   //   }

//   //   const updatedForm = {
//   //     ...this.state.formFields,
//   //   };

//   //   let key = fieldName;
//   //   const value = e.currentTarget.value;

//   //   if (key.includes('billingInfo.')) {
//   //     key = key.split('.').pop()!;
//   //     updatedForm.billingInfo![key] = value;
//   //     if (updatedForm.sameAsBilling) {
//   //       updatedForm.clientFacingInfo![key] = value;
//   //     }
//   //   } else if (key.includes('clientFacingInfo.')) {
//   //     key = key.split('.').pop()!;
//   //     updatedForm.clientFacingInfo![key] = value;
//   //   } else if (key === 'sameAsBilling') {
//   //     updatedForm[key] = e.currentTarget.checked;
//   //     if (e.currentTarget.checked) {
//   //       const targetBillingInfo = {
//   //         ...this.state.formFields.billingInfo,
//   //       };
//   //       updatedForm.clientFacingInfo = targetBillingInfo;
//   //       // defaultBillingInfoValues();
//   //     }
//   //   } else {
//   //     updatedForm[key] = value;
//   //   }

//   //   this.setState({ formFields: updatedForm });
//   // }

//   // private handleTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
//   //     const { value } = e.currentTarget;
//   //     this.setState({
//   //         estimateNotes: value,
//   //     });
//   // };

//   private handleChangeCustomState = (value: string, key: string): void => {
//     const splitKey = key.split('.')[0];

//     if (splitKey === 'billingInfo' && this.isSharedSettingsReadOnly()) {
//       return;
//     }

//     if (splitKey === 'clientFacingInfo' && this.isClientFacingSettingsReadOnly()) {
//       return;
//     }

//     switch (splitKey) {
//       case 'billingInfo':
//         this.setState((prev) => {
//           const isBillingSame = prev.formFields.sameAsBilling;
//           return {
//             ...prev,
//             formFields: {
//               ...prev.formFields,
//               billingInfo: {
//                 ...prev.formFields.billingInfo,
//                 state: value,
//               },
//               clientFacingInfo: isBillingSame
//                 ? {
//                     ...prev.formFields.clientFacingInfo,
//                     state: value,
//                   }
//                 : { ...prev.formFields.clientFacingInfo },
//             },
//           };
//         });
//         break;
//       case 'clientFacingInfo':
//         this.setState((prev) => {
//           return {
//             ...prev,
//             formFields: {
//               ...prev.formFields,
//               clientFacingInfo: {
//                 ...prev.formFields.clientFacingInfo,
//                 state: value,
//               },
//             },
//           };
//         });
//         break;
//       default:
//         return;
//     }
//   };

//   private handleFieldState = (value: string, name: string) => {
//     // if (name === "billingInfo.state" || name === "clientFacingInfo.state") {
//     //     return;
//     // }

//     if (name.startsWith('billingInfo.') && this.isSharedSettingsReadOnly()) {
//       return;
//     }

//     if (name.startsWith('clientFacingInfo.') && this.isClientFacingSettingsReadOnly()) {
//       return;
//     }

//     const updatedForm = { ...this.state.formFields };

//     let key = name;

//     if (key.includes('billingInfo.')) {
//       key = key.split('.').pop()!;
//       updatedForm.billingInfo![key] = value;
//       if (updatedForm.sameAsBilling) {
//         updatedForm.clientFacingInfo![key] = value;
//       }
//     } else if (key.includes('clientFacingInfo.')) {
//       key = key.split('.').pop()!;
//       updatedForm.clientFacingInfo![key] = value;
//     } else {
//       updatedForm[key] = value;
//     }

//     this.setState({ formFields: updatedForm });
//   };

//   // private handleKeyPressForm(e: KeyboardEvent<HTMLElement>) {
//   //   if (e.which === 13 && (e.target as HTMLTextAreaElement).name !== 'notes') {
//   //     e.preventDefault();
//   //     return;
//   //   }
//   // }

//   // private handleConfirmCancellation = () => {
//   //   this.closeCancellationModal();
//   //   this.cancelMembership();
//   // };

//   // @Bind()
//   // private async cancelMembership(): Promise<void> {
//   //   const accountId = this.getManagedAccountId();
//   //   const res = await cancelSubscription(accountId);
//   //   if (res.status === 'canceled') {
//   //     this.setState({ isCancellationMembership: true });
//   //   }
//   //   // if (res.error) {
//   //   //     ///
//   //   // } else {
//   //   //     this.setState({ isCancellationMembership: true });
//   //   // }
//   // }

//   // @Bind()
//   // private async handleSubmitForm(e: FormEvent<HTMLFormElement>): Promise<void> {
//   //   e.preventDefault();

//   //   const { dispatch } = this.props;
//   //   const { formFields, canEditSharedSettings } = this.state;
//   //   if (!canEditSharedSettings) {
//   //     return;
//   //   }

//   //   const accountId = this.getManagedAccountId();

//   //   const res = await updateAccount({
//   //     accountId: this.props.accountId,
//   //     targetAccountId: accountId,
//   //     billingInfo: formFields.billingInfo,
//   //     clientFacingInfo: formFields.clientFacingInfo,
//   //     sameAsBilling: formFields.sameAsBilling,
//   //     avatarId: formFields.avatarId,
//   //   });

//   //   if (res.error) {
//   //     if (res.message === 'ValidationError') {
//   //       //     const errors = (res.payload as Error as ValidationError).errors;
//   //       //     throw FormValidationError.fromErrorDictionary(errors);
//   //       // } else {
//   //       throw new Error(res.message);
//   //     }
//   //   } else {
//   //     try {
//   //       await updateCrispProfile(accountId, formFields.billingInfo);
//   //     } catch {}

//   //     try {
//   //       await updateStripeProfile(accountId, formFields.billingInfo);
//   //     } catch {}

//   //     const notification: NotificationsModule.Notification = {
//   //       id: 0,
//   //       message: 'Success!',
//   //       subMessage: 'Billing info updated.',
//   //       type: 'info',
//   //     };
//   //     dispatch(NotificationsModule.addNotification(notification));
//   //     // onClientSaved({
//   //     //     ...this.state.formFields,
//   //     //     subClients: client.subClients,
//   //     //     subClientsIds: client.subClientsIds,
//   //     // });
//   //   }
//   // }
// }

function mapStateToProps(state: RootState, ownProps: {}): AccountSettingsProps {
  let accountId =
    parseFloat(localStorage.getItem('ownerAccountId') || '0') ||
    parseFloat(localStorage.getItem('accountId') || '0');
  let managedAccountId = parseFloat(localStorage.getItem('accountId') || '0');
  let ownerId = parseFloat(localStorage.getItem('ownerAccountId') || '0');
  return {
    accountId: accountId,
    managedAccountId: managedAccountId,
    ownerId: ownerId,
    // cardDigits: state.account.cardDigits,
    quickbookConnected: state.account.quickbookConnected,
    userRole:
      localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'office_worker'
        ? (localStorage.getItem('role') as 'admin' | 'office_worker')
        : 'office_worker',
    type: localStorage.getItem('status') === 'subscribed' ? 'subscribed' : 'unsubscribed',
  };
}

export const AccountSettingsContainer = connect(mapStateToProps)(AccountSettingsPage);
